import Vue from "vue";
import Vuex from "vuex";
import axios from "../config/axios";
import router from "../router";
import { authFirebase } from "../../firebase_instant";
import moment from "moment";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});

export default new Vuex.Store({
  plugins: [vuexLocal.plugin],
  state: {
    user: null,
    datas: null,
    uid: '',
    datas_genders: [],
    datas_genders_keys: [],
    datas_categories: [],
    datas_categories_keys: [],
    datas_provinces: [],
    datas_provinces_keys: [],
    timeExpire: 0,
  },
  mutations: {
    fetchData(state, payload) {
      state.datas_genders = payload.genderArray;
      state.datas_genders_keys = payload.genderArrayKeys;
      state.datas_categories = payload.categoriesArray;
      state.datas_categories_keys = payload.categoriesArrayKeys;
      state.datas_provinces = payload.provinceArray;
      state.datas_provinces_keys = payload.provinceArrayKeys;
    },
    setUserName(state, payload) {
      state.user = payload;
    },
    setDataFromSql(state, payload) {
      state.datas = payload;
    },
    setUid(state, payload) {
      state.uid = payload;
    },
    setTimeExpire(state, payload) {
      state.timeExpire = payload;
    }
  },
  actions: {
    async check2Fa({ commit }, { email, token }) {
      try {
        const { data } = await axios.post('/2fa/enable', {
          email,
          token
        })
        return data
      } catch (error) {
        return error
      }
    },
    async fetchData({ commit }) {
      try {
        const dataAlls = await axios.get("/datas/", {
          headers: {
            'Authorization': 'Bearer ' + this.state.uid
          }
        });
        if (dataAlls.status == 200) {
          const dataValue = dataAlls.data;
          const genderArray = Object.values(
            JSON.parse(JSON.stringify(dataValue.genderAlls))
          );
          const genderArrayKeys = Object.keys(dataValue.genderAlls);

          const categoriesArray = Object.values(
            JSON.parse(JSON.stringify(dataValue.categories))
          );
          const categoriesArrayKeys = Object.keys(dataValue.categories);

          const provinceArray = Object.values(dataValue.provinces);
          const provinceArrayKeys = Object.keys(dataValue.provinces);

          commit("fetchData", {
            genderArray,
            categoriesArray,
            categoriesArrayKeys,
            provinceArray,
            provinceArrayKeys,
            genderArrayKeys,
          });
        }
      } catch (error) {
        console.log('error :>> ', error);
      }

    },
    login({ commit }, { email, password }) {
      try {
        return authFirebase
          .auth()
          .signInWithEmailAndPassword(email, password)
          .then(async (firebaseUser) => {
            const user = firebaseUser.user;
            const idToken = await user.getIdToken();
            commit("setUid", idToken);
            // commit("setUserName", firebaseUser.user.email);
            // router.push({ name: "admin" });
            return idToken;
          })
      } catch (error) {
        return error
      }
    },

    async fetchDataFromSql({ commit }) {
      const dataAlls = await axios.get("/reports", {
        headers: {
          'Authorization': 'Bearer ' + this.state.uid
        }
      });
      const dataServer = dataAlls.data.map((user) => {
        return {
          name: user.name,
          gender:
            user.gender == "male"
              ? "ชาย"
              : user.gender == "female"
                ? "หญิง"
                : "อื่นๆ",
          mobile: user.mobile,
          email: user.email,
          birthDay:
            moment(user.birthDay)
              .format(`DD MMMM YYYY `)
              .substring(0, 6) == "29 Feb"
              ? moment(user.birthDay)
                .locale("th")
                .add(543, "y")
                .format("29 MMMM YYYY")
              : moment(user.birthDay)
                .locale("th")
                .add(543, "y")
                .format("DD MMMM YYYY"),
          province: user.province,
          categories: user.categories,
          createdAt: user.createdAt,
          policy_email: user.policy_email,
          policy_other: user.policy_other,
          policy_sms: user.policy_sms,
          policy_terms: user.policy_terms,
          policy_voice: user.policy_voice,
        };
      });
      commit("setDataFromSql", dataServer);
    },
  },
  getters: {
    dataGenderFromState(state) {
      const dataGender = {
        keysGender: state.datas_genders_keys.map((item) => {
          if (item == "female") {
            return (item = "หญิง");
          } else if (item == "male") {
            return (item = "ชาย");
          } else {
            return (item = "อื่นๆ");
          }
        }),
        valuesGender: state.datas_genders,
      };
      return dataGender;
    },
    dataCategoriesFromState(state) {
      const dataCategories = {
        valuesCategories: state.datas_categories,
        keysCategories: state.datas_categories_keys,
      };
      return dataCategories;
    },
    dataProvinceFromState(state) {
      const dataProvinces = {
        keysProvinces: state.datas_provinces_keys,
        valuesProvinces: state.datas_provinces,
      };
      return dataProvinces;
    },
    reportData(state) {
      if (state.datas) {
        return state.datas;
      }
    },
  },
});
